import { Link } from "react-router-dom";

export function SiteFooter() {
  return (
    <footer className="border-t border-rule mt-16">
      <div className="px-6 md:px-10 py-5 flex flex-wrap items-center justify-between gap-4 text-xs text-muted-foreground">
        <div>
          © {new Date().getFullYear()} Flyg.info — En minimal flygradar.
        </div>
        <div className="flex items-center gap-4">
          <Link to="/reseservice" className="hover:text-foreground transition-colors">
            Reseservice <span>(annons)</span>
          </Link>
          <a
            href="https://xn--frsenad-90a.se/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            försenad.se
          </a>
        </div>
      </div>
    </footer>
  );
}